import React from 'react';
import Select from 'react-select';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';
import Api from './Config';
import Alert from './Alert';
import BooleanAlert from './BooleanAlert';

export default class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalValue: { name: '', remark: '', divisions: [] },
      apps: [],
      formMode: null,
      selected_club: null,
      groups: [],
      active: false,
      reloadList: 0,
    };

    this.loadRows = this.loadRows.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.doDialogSave = this.doDialogSave.bind(this);
    this.setGroupActive = this.setGroupActive.bind(this);
  }

  componentDidMount() {
    Api.getApps()
      .then((apps) => {
        const allApps = _.map(apps, (a) => {
          a.clubname = unescape(a.clubname);
          return a;
        });

        this.setState({
          apps: allApps,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  itemSelected(obj) {
    this.setState({ selected_club: obj });
    this.setState({ reloadList: this.state.reloadList + 1 });
  }

  async loadRows(startIdx, queryAmount) {
    const results = await Api.getGroups(this.state.selected_club.club_id, startIdx, queryAmount);

    let resultGroups = results.data;
    if (startIdx > 0) {
      resultGroups = this.state.groups.concat(resultGroups);
    }

    const hasActiveRows = parseInt(results.activeRows) > 0 ? true : false;
    this.setState({ groups: resultGroups, active: hasActiveRows });

    return {
      data: results.data,
      maxRows: results.maxRows,
    };
  }

  doDialogSave() {
    if (this.state.modalValue.name.trim() === '') {
      this.alert.open('Error', 'Name should be given');
      return;
    }

    Api.addUpdateGroup(
      this.state.selected_club.club_id,
      this.state.modalValue.name,
      this.state.modalValue.remark,
      this.state.modalValue.divisions,
      this.state.current_id,
      this.state.formMode,
      this.state.active
    )
      .then((data) => {
        if (data.SUCCESS === true) {
          this.setState({ formMode: null, reloadList: this.state.reloadList + 1 });
          return;
        }
        throw new Error(data.ERROR);
      })
      .catch((err) => {
        this.alert.open('Error', `${err}`);
      });
  }

  async setGroupActive(checked) {
    const result = await Api.setActiveGroup(this.state.selected_club.club_id, checked);
    if (result.SUCCESS) {
      this.setState({ active: checked });
      const message = checked ? 'Successfully set groups to Active' : 'Successfully set groups to Inactive';
      this.alert.open('Success', message);
    } else {
      console.log(result.ERROR);
      this.alert.open('Error', 'Something went wrong. Please try again.');
    }
  }

  getTableCell({ dataKey, rowData }) {
    let cellItem;

    switch (dataKey) {
      case 'edit':
        cellItem = (
          <button
            onClick={() => {
              this.setState({
                modalValue: {
                  name: rowData.group_code,
                  remark: rowData.group_remark,
                  divisions: rowData.divisions,
                },
                current_id: rowData.id,
                formMode: 'Edit',
              });
            }}
            type="button"
            className="btn btn-primary btn-sm"
          >
            Edit
          </button>
        );
        break;
      case 'delete':
        cellItem = (
          <button
            onClick={() => {
              this.booleanAlert.open('Confirm Delete', `Are you sure you want to delete ${rowData.group_code}?`, () => {
                Api.deleteGroup(rowData.id)
                  .then(({ SUCCESS, ERROR }) => {
                    if (SUCCESS) {
                      this.setState({ groups: this.state.groups.filter((item) => item.id != rowData.id) });
                    } else {
                      this.alert.open('Error', `${ERROR}`);
                    }
                  })
                  .catch((err) => {
                    this.alert.open('Error', `${err}`);
                  });
              });
            }}
            type="button"
            className="btn btn-danger btn-sm"
          >
            Delete
          </button>
        );
        break;
    }

    return cellItem;
  }

  renderRows() {
    return (
      <InfiniteList lists={this.state.groups} loadRows={this.loadRows} reloadList={this.state.reloadList}>
        {({ onRowsRendered, registerChild, width }) => (
          <Table
            ref={registerChild}
            onRowsRendered={onRowsRendered}
            width={width}
            height={800}
            headerHeight={40}
            rowStyle={{
              borderBottom: '1px solid #ddd',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            rowHeight={50}
            rowCount={this.state.groups.length}
            rowGetter={({ index }) => this.state.groups[index]}
          >
            <Column label="Name" dataKey="group_code" width={width / 2} />
            <Column label="Remark" dataKey="group_remark" width={width / 2} />
            <Column label="Edit" dataKey="edit" cellRenderer={this.getTableCell} width={200} />
            <Column label="Delete" dataKey="delete" cellRenderer={this.getTableCell} width={200} />
          </Table>
        )}
      </InfiniteList>
    );
  }

  getEditForm() {
    const { modalValue } = this.state;

    return (
      <div className="modal show ">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">{this.state.formMode} Group</div>
            <div className="modal-body">
              <div className="form-group">
                <label>Group Name</label>
                <input
                  value={modalValue.name}
                  onChange={(e) => {
                    this.setState({ modalValue: { ...modalValue, name: e.target.value } });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Group Remark</label>
                <input
                  value={modalValue.remark}
                  onChange={(e) => {
                    this.setState({ modalValue: { ...modalValue, remark: e.target.value } });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
            </div>
            {false && (
              <div className="panel panel-default" style={{ margin: 10 }}>
                <div className="panel-heading">Divisions</div>
                <div className="panel-body">
                  <div>
                    {modalValue.divisions.map((a, counter) => (
                      <div
                        style={{
                          margin: 4,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                        key={`row${counter}`}
                      >
                        <span style={{ width: 30 }}>{counter + 1}</span>
                        <input
                          type="text"
                          value={a}
                          onChange={(e) => {
                            modalValue.divisions[counter] = e.target.value;
                            this.setState({ modalValue });
                          }}
                          className="form-control"
                          style={{ flex: 1 }}
                        />
                        <button
                          type="button"
                          onClick={(e) => {
                            modalValue.divisions.splice(counter, 1);
                            this.setState({ modalValue });
                          }}
                          className="btn btn-xs btn-danger"
                          style={{ marginLeft: 10 }}
                        >
                          remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="panel-footer">
                  <button
                    type="button"
                    onClick={(e) => {
                      modalValue.divisions.push('');
                      this.setState({ modalValue });
                    }}
                    className="btn btn-primary btn-xs"
                  >
                    Add New
                  </button>
                </div>
              </div>
            )}

            <div className="modal-footer">
              <button onClick={this.doDialogSave} type="button" className="btn btn-primary">
                Save
              </button>
              <button
                type="button"
                onClick={() => {
                  this.setState({ formMode: null });
                }}
                className="btn btn-info"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { selected_club, apps } = this.state;
    return (
      <div>
        {this.state.formMode && this.getEditForm()}
        <h3>Groups</h3>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Select App:</label>
            <Select
              onChange={(obj) => {
                this.itemSelected(obj);
              }}
              value={selected_club}
              getOptionValue={(a) => a.club_id}
              getOptionLabel={(a) => a.clubname}
              options={apps}
            />
          </div>
        </div>
        {this.state.selected_club && (
          <div>
            <div className="form-group">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={this.state.active}
                    onChange={(e) => {
                      this.setGroupActive(e.target.checked);
                    }}
                  />
                  Set Groups to Active
                </label>
              </div>
            </div>
            <button
              type="button"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.setState({ formMode: 'Add', modalValue: { name: '', remark: '', divisions: [] } });
              }}
              className="btn btn-xs btn-primary"
            >
              Add New
            </button>
            {this.renderRows()}
          </div>
        )}
        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />
        <Alert
          ref={(ref) => {
            this.alert = ref;
          }}
        />
      </div>
    );
  }
}
